import * as types from './mutation-types'

export const mutations = {
  [types.GET_NOTICES_LOADING](state) {
    state.current.loading = true
    state.current.data = null
    state.current.error = false
  },
  [types.GET_NOTICES_ERROR](state, error) {
    state.current.loading = false
    state.current.data = null
    state.current.error = error
  },
  [types.GET_NOTICES_COMPLETE](state, payload) {
    state.current.loading = false
    state.current.data = payload
    state.current.error = false
  }
}



//////////////////
// WEBPACK FOOTER
// ../nonameapp-common-modules/src/store/modules/notices/mutations.js
// module id = null
// module chunks = 